import { render, staticRenderFns } from "./RegistroEstudiante.vue?vue&type=template&id=7fee7c09&scoped=true"
import script from "./RegistroEstudiante.vue?vue&type=script&lang=js"
export * from "./RegistroEstudiante.vue?vue&type=script&lang=js"
import style0 from "./RegistroEstudiante.vue?vue&type=style&index=0&id=7fee7c09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fee7c09",
  null
  
)

export default component.exports